import React from 'react'
import ParticlesConfig from '../../utils/particles'
import Particles from 'react-particles-js'
import PropTypes from 'prop-types'
import { View } from 'react-native'

const ParticlesBackground = ({ children, ...props }) => {
  return (
    <>
      <Particles
        params={ParticlesConfig}
        style={{
          position: 'absolute',
          flex: 1,
          width: '100%',
          height: '100%',
          backgroundColor: '#070C10',
          zIndex: 1
        }}
      />
      <View style={{ flex: 1, zIndex: 2 }}>{children}</View>
    </>
  )
}

ParticlesBackground.propTypes = {
  children: PropTypes.any
}

export default ParticlesBackground
